
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.621 3.625H1.25c-.69 0-1.25.56-1.25 1.25v8.226c0 .69.56 1.25 1.25 1.25h10.371c.69 0 1.25-.56 1.25-1.25V4.875c0-.69-.56-1.25-1.25-1.25zM13.704 10.7L18 13.045V4.958l-4.296 2.345V10.7z"}})])
          )
        }
      }
    